import { GET_STUDENT_COURSE_PROGRESS} from "./actionTypes";

const initialStates = {
    loading:true,
    data:[],
    categoryRecords:[],
    error:" ",
}

 const studentCourseProgressReducer = (state = initialStates,action)=>{
    switch (action.type) {
        case  GET_STUDENT_COURSE_PROGRESS:
            return {
                courseProgress: action.payload,
            }
        
        default:
            return state;
    }
}

export default studentCourseProgressReducer;